import type { InsightChatItem } from '@wundo/shared/insightChat.ts';

/**
 * Add an item that arrived, or replace the one it finishes. Kept in the order
 * the conversation was written, which is the order of the ids.
 */
export function upsertChatItem(
  items: readonly InsightChatItem[],
  item: InsightChatItem,
): InsightChatItem[] {
  const others = items.filter((existing) => existing.id !== item.id);

  return [...others, item].sort((a, b) => Number(a.id) - Number(b.id));
}
